import React, { useContext } from "react";
import "./TextareaInput.css";
import { useTranslation } from "react-i18next";
import { ThemeContext } from "../../../../..";

const TextareaInput = ({
  name,
  errors,
  register,
  label,
  type,
  mandatory,
  value,
  disabled = false,
  textareaConfig,
  style
}) => {
  const { onChange, ...registerParams } = register(name);
  const { t } = useTranslation();
  const { theme } = useContext(ThemeContext);
  //style={{ marginLeft: textareaConfig ? "125%" : "auto", width: textareaConfig ?"175%":"auto" }}
  return (
    <div className="input_text-form" >  
      <label style={{ color: theme === "light" ? "black" : undefined }}>
        {t(label)}
        {mandatory && <span className="asterisk">*</span>}
      </label>
      <textarea
        style={{
          ...(textareaConfig ? {
            color: "black",
           
        
          
          } : {color: "black",}),
        }}
        autoComplete="off"
        className={`form_text_area form-control ${theme === "light" ? "form-control-sm-light" : "form-control-sm"
          } ${errors[name] ? "error__border--color" : "form__input--area"}`}
        type={type}
        onChange={(event) => {
          onChange(event);
        }}
        {...registerParams}
        disabled={disabled}
      />
      <div className="error__message">{errors[name]?.message}</div>
    </div>
  );
};

export default TextareaInput;
